import { render, staticRenderFns } from "./dashboard-entities-loading.vue?vue&type=template&id=1fa4645e&scoped=true&"
import script from "./dashboard-entities-loading.vue?vue&type=script&lang=ts&"
export * from "./dashboard-entities-loading.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-entities-loading.vue?vue&type=style&index=0&id=1fa4645e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa4645e",
  null
  
)

export default component.exports